const getValueFromEnv = (key: string): string | undefined => {
  return process.env[key] || ((window as any).__ENV__ || {})[key];
};

const errorEnvVarRequired = (key: string): Error => {
  return new Error(`${key} is a required environment variable!`);
};

const envString = (key: string, defaultValue?: string): string => {
  const value = getValueFromEnv(key);
  if (!value && defaultValue === undefined) {
    throw errorEnvVarRequired(key);
  }

  return value || defaultValue || '';
};

const envInt = (key: string, defaultValue?: number): number => {
  const value = getValueFromEnv(key);
  if (!value && defaultValue  === undefined) {
    throw errorEnvVarRequired(key);
  }

  if (value) {
    return parseInt(value, 10);
  }

  return defaultValue || 0;
};

const envBool = (key: string, defaultValue?: boolean): boolean => {
  const value = getValueFromEnv(key);
  if (!value && defaultValue  === undefined) {
    throw errorEnvVarRequired(key);
  }

  if (value) {
    return value.toLowerCase() === 'true' || !!+value;
  }

  return defaultValue || false;
};

interface IConfig {
  bugsnag: {
    apiKey: string;
    stage: string;
    version: string;
  };
  env: string;
  fullstory: {
    org: string;
  };
  magic: {
    apiPublicKey: string;
  };
  zendesk: {
    widgetKey: string;
  };
  publicUrl: string;
  testInt: number;
  toggleMsw: boolean;
}

let _config: IConfig;
const config = (): IConfig => {
  if (_config) {
    return _config;
  }

  _config = {
    bugsnag: {
      apiKey: envString('REACT_APP_BUGSNAG_API_KEY', ''),
      stage: envString('REACT_APP_BUGSNAG_STAGE', 'development'),
      version: envString('REACT_APP_BUGSNAG_VERSION', 'unset'),
    },
    env: envString('NODE_ENV', 'development'),
    fullstory: {
      org: envString('REACT_APP_FULLSTORY_ORG', ''),
    },
    magic: {
      apiPublicKey: envString('REACT_APP_MAGIC_API_PUBLIC_KEY'),
    },
    zendesk: {
      widgetKey: envString('REACT_APP_ZENDESK_WIDGET_KEY', ''),
    },
    publicUrl: envString('PUBLIC_URL'),
    testInt: envInt('REACT_APP_TEST_INT', 1),
    toggleMsw: envBool('REACT_APP_TOGGLE_MSW', false),
  };

  return _config;
};

const isProduction = (): boolean => {
  return config().env === 'production';
};

const isStaging = (): boolean => {
  return config().env === 'staging';
};

const isDev = (): boolean => {
  return config().env === 'development';
};

export default config;
export {
  isProduction,
  isStaging,
  isDev,
};
